<form [formGroup]="formGroup" class="app-form">
  <mat-form-field class="app-block">
    <input matInput formControlName="name" i18n-placeholder placeholder="Network name" [appAutofocus]>
  </mat-form-field>
</form>
<div>
  <button mat-raised-button (click)="save()" [disabled]="formGroup.invalid" i18n>SAVE</button>
</div>